import * as React from 'react';
import { ReactElement } from 'react';
import './style.css';

interface IProps {
  label?: string;
  statusText?: string;
  id?: string;
}

const Label = ({ label, statusText, id }: IProps): ReactElement => (
  <div className="form-label__wrapper">
    <label className="form-label" htmlFor={id}>
      {label}
    </label>
    <span className="form-label__status-text">{statusText}</span>
  </div>
);

export default Label;
